import { render, staticRenderFns } from "./AdminInputListWrapper.vue?vue&type=template&id=6ad5be35&scoped=true&"
import script from "./AdminInputListWrapper.vue?vue&type=script&lang=js&"
export * from "./AdminInputListWrapper.vue?vue&type=script&lang=js&"
import style0 from "./AdminInputListWrapper.vue?vue&type=style&index=0&id=6ad5be35&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad5be35",
  null
  
)

export default component.exports